import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-locize-backend';
// import LastUsed from 'locize-lastused';
// import Editor from 'locize-editor';

const LOCIZE_PROJECT_ID = process.env.REACT_APP_LOCIZE_PROJECT_ID;
const LOCIZE_API_KEY = process.env.REACT_APP_LOCIZE_API_KEY;

const locizeOptions = {
  projectId: LOCIZE_PROJECT_ID,
  apiKey: LOCIZE_API_KEY, // YOU should not expose your apps API key to production!!!
  referenceLng: 'pl',
};

// Helper function to check if hostname is localhost
const isLocalhost = (hostname) => {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('127.') ||
    hostname === '[::1]'
  );
};

// Function to determine application type based on domain
export const getAppType = () => {
  const { hostname, search } = window.location;

  if (isLocalhost(hostname)) {
    const urlParams = new URLSearchParams(search);
    const appParam = urlParams.get('app');
    if (appParam) {
      if (appParam === 'reset') {
        localStorage.removeItem('dev_app_type');
        return 'quiz';
      }
      const validApps = ['quiz', 'diabetino-pl', 'diabetino-cz'];
      if (validApps.includes(appParam)) {
        localStorage.setItem('dev_app_type', appParam);
        return appParam;
      }
    }
    const storedAppType = localStorage.getItem('dev_app_type');
    if (storedAppType && ['quiz', 'diabetino-pl', 'diabetino-cz'].includes(storedAppType)) {
      return storedAppType;
    }
    return 'quiz';
  }

  if (
    hostname === 'cz.diabetino.diet' || 
    hostname === 'czv2.diabetino.diet' ||
    hostname.endsWith('.cz.diabetino.diet') ||
    hostname.endsWith('.czv2.diabetino.diet')
  ) {
    return 'diabetino-cz';
  }

  if (
    hostname === 'pl.diabetino.diet' ||
    hostname === 'www.diabetino.diet' ||
    hostname === 'diabetino.diet' ||
    hostname.endsWith('.pl.diabetino.diet') ||
    hostname.endsWith('.www.diabetino.diet')
  ) {
    return 'diabetino-pl';
  }

  return 'quiz';
};

// --------- LOCIZE ---------
i18n
  // i18next-locize-backend
  // loads translations from your project, saves new keys to it (saveMissing: true)
  // https://github.com/locize/i18next-locize-backend
  .use(Backend)
  // locize-lastused
  // sets a timestamp of last access on every translation segment on locize
  // -> safely remove the ones not being touched for weeks/months
  // https://github.com/locize/locize-lastused
  // .use(LastUsed)
  // locize-editor
  // InContext Editor of locize ?locize=true to show it
  // https://github.com/locize/locize-editor
  // .use(Editor)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  // .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'pl',
    debug: false,
    saveMissing: false,
    // defaultLanguage: 'pl',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: locizeOptions,
    locizeLastUsed: locizeOptions,
    editor: {
      ...locizeOptions,
      onEditorSaved: async (lng, ns) => {
        // reload that namespace in given language
        await i18n.reloadResources(lng, ns);
        // trigger an event on i18n which triggers a rerender
        // based on bindI18n below in react options
        i18n.emit('editorSaved');
      },
    },
    react: {
      bindI18n: 'languageChanged editorSaved',
      wait: true,
      // wait: false
    },
  });

export default i18n;
